<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      :model="model"
      :required-date-value="$parent.dateRange"
      :use-action="false"
      :use-default-action="false"
      entity-name="分类统计报表"
      icon="mdi-cards"
    />
  </div>
</template>

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import categoryReport from '@/model/dataLayer/api/bills/CategoryReport'

export default {
  components: {
    IkDataTable
  },
  data () {
    return {
      model: categoryReport
    }
  },
  watch: {
    '$parent.dateRange': {
      handler: function (val) {

      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>
